import React from "react";
import Icon from 'storybookComponents/Icon';
import SelectorComponent from "components/SelectorComponents"

const filterOptions = [
  {
    id: "active",
    value: "Active"
  },
  {
    id: "inactive",
    value: "Inactive"
  },
]

export default React.memo(({ classes, status, showFilter, handleFilter }) => {

  const getLabelValues = (value) => {
    let _value = ""
    if (value.length === 0) {
      _value = "Select Status"
    } else if (value.length === 2) {
      _value = "All"
    } else {
      if (value[0] === "active") {
        _value = "Active"
      } else {
        _value = "Inactive"
      }
    }
    return <div className={classes.dropDownSelect}>{_value}</div>
  }
  return (
    <thead>
      <tr>
        <td className={`${classes.headerCell}`}>
          Referral Campaign Title
          &nbsp;
              <Icon type="icon-arrow-down" size="xs" />
        </td>
        <td>
        </td>
        <td className={`${classes.headerCell}`}>
          Created On
           </td>
        <td className={`${classes.headerCell}`}>
          # Residents
           </td>
        <td className={`${classes.headerCell}`}>
          # Friends
            </td>
        <td className={`${classes.headerCell} ${classes.activeCell}`}>
          Active
      </td>
        <td>
        </td>
        <td className={classes.menuItem}>
        </td>
      </tr>
      {showFilter ?
        < tr >
          <td className={`${classes.headerCell} title-column`}>
          </td>
          <td>
          </td>
          <td className={`${classes.headerCell}`}>
          </td>
          <td className={`${classes.headerCell}`}>
          </td>
          <td className={`${classes.headerCell}`}>
          </td>
          <td className={`${classes.headerCell} ${classes.activeCell} ${classes.filterCell}`}>
            <div className={classes.dropDownContainer}>
              <SelectorComponent
                optionValue={filterOptions}
                placeholder="Select Status"
                getCustomLabel={getLabelValues}
                multiple={true}
                searchPlaceHolder="Enter Campaigns name here..."
                onChange={handleFilter}
                value={status}
                disableSearch
                disableAllSelect
                height={105}
                width={150}
                // mainWidth={135}
                disableButton={true}
              />
            </div>
          </td>
          <td>
          </td>
          <td className={classes.menuItem}>
          </td>
        </tr> :
        null
      }
    </thead>
  )
})